<form *ngIf="fields && render.form" [ngClass]="{'invalid-submit': invalidSubmit}" [formGroup]="form" (submit)="save()">
  <div class="Loyalty ui-g-12 ui-md-12 ui-lg-12">
    <div class="ui-g">
      <div class="ui-g-9 ui-md-9 ui-lg-9">
        <h1 class="step-title" *ngIf="!editMode">{{ 'card_batch.add_title' | translate }}</h1>
        <h1 class="step-title" *ngIf="editMode">{{ 'card_batch.edit_title' | translate }}</h1>
      </div>
      <div class="ui-g-3 ui-md-3 ui-lg-3 form-button-row">
        <button pButton class="k-generic-btn" type="button" icon="fa fa-arrow-left" iconPos="left" routerLink="/loyalty/card_batch" label="{{ 'common.back' | translate }}"></button>
        <button pButton class="k-generic-btn" (click)="save()" type="button" icon="fa fa-floppy-o" iconPos="left" label="{{'common.save' | translate}}" ></button>
      </div>
    </div>

    <div class="card">
      <div class="ui-g ui-fluid">

        <div class="ui-g-12 ui-md-12" *ngIf="cardbatchId">
          <span class="label">{{ 'Id' }}: {{cardbatchId}}</span>
        </div>

        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !fields.channel_id.nullable}">{{ fields.channel_id.keyName }}</span>
          <p-dropdown [options]="channels" formControlName="channel_id" [disabled]="readonly" (onChange)="onChannelChange()"></p-dropdown>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="form" [validation]="fields.channel_id"></app-validation-msg>
        </div>

        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !fields.store_id.nullable}">{{ fields.store_id.keyName }}</span>
          <p-dropdown [options]="stores" [filter]="true" formControlName="store_id" [disabled]="readonly || render.store == false || stores.length == 0"></p-dropdown>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="form" [validation]="fields.store_id"></app-validation-msg>
        </div>

        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !fields.card_type_pid.nullable}">{{ fields.card_type_pid.keyName }}</span>
          <p-dropdown [options]="cardTypes" formControlName="card_type_pid" [disabled]="readonly"></p-dropdown>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="form" [validation]="fields.card_type_pid"></app-validation-msg>
        </div>

      </div>

      <div class="ui-g ui-fluid">

        <div class="ui-g-10 ui-md-4">
            <span class="label" [ngClass]="{'required': true}">{{ fields.cluster_head_id.keyName }}</span>
            <p-autoComplete
                #clusterHead
                id="clusterHeadAutocomplete"
                [suggestions]="clustersHead"
                [(ngModel)]="selected.clusterHead"
                value="selected.clusterHead.clusterHeadId"
                formControlName="cluster_head_id"
                (onSelect)="clusterHeadIdSelect($event)"
                (onBlur)="checkClusterSelected($event)"
                (completeMethod)="filterClusterHeadSingle($event)"
                placeholder="{{ fields.cluster_head_id.keyName }}"
                [minLength]="2"
                field="headDescription">
              <ng-template let-customerCluster pTemplate="item">
                <div class="ui-helper-clearfix" style="border-bottom:1px solid #D5D5D5">
                  <div>{{ customerCluster.headDescription }} - {{ customerCluster.date_start }} / {{ customerCluster.date_end }}
                    <span *ngIf="customerCluster.code; else noCC">(CODE: {{ customerCluster.code
                      }})</span>
                    <ng-template #noCC>
                      (NO CC)
                    </ng-template>
                  </div>
                </div>
              </ng-template>
            </p-autoComplete>
            <span class="input-error-notification" *ngIf="invalidSubmit && form.controls['cluster_head_id'].errors?.required && !selected.checkClusterHead">{{ 'common.required_error' |
              translate }}</span>
            <span class="input-error-notification" *ngIf="invalidSubmit && form.controls['cluster_head_id'].errors?.required && selected.checkClusterHead">{{ 'common.selectCluster' |
              translate }}</span>
        </div>

          <div class="ui-g-10 ui-md-4">
            <span class="label" [ngClass]="{'required': !fields.card_def_id.nullable}">{{ fields.card_def_id.keyName }}</span>
            <p-dropdown [options]="cardDefinitions" formControlName="card_def_id" [disabled]="readonly || render.cardDefinitions == false || cardDefinitions.length == 0"></p-dropdown>
            <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="form" [arrayValidators]="[validators.integerNotNegative]" [validation]="fields.card_def_id"></app-validation-msg>
          </div>

      </div>

        <div class="ui-g ui-fluid">

          <div class="ui-g-10 ui-md-4">
            <span class="label" [ngClass]="{'required': !fields.num_min.nullable}">{{ fields.num_min.keyName }}</span>
            <input type="number" pInputText class="fieldInput" formControlName="num_min"
                  (change)="changeMin($event, maxNum.value)" [max]="maxNum.value" [attr.disabled]="readonly ? '' : null" #minNum data-testid="minNum" />
            <span class="input-error-notification" *ngIf="invalidSubmit && form.controls.num_min.errors?.integerNotNegative">Solo valori interi positivi</span>
            <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="form" [arrayValidators]="[validators.integerNotNegative]" [validation]="fields.num_min"></app-validation-msg>
          </div>

          <div class="ui-g-10 ui-md-4">
            <span class="label" [ngClass]="{'required': !fields.num_max.nullable}">{{ fields.num_max.keyName }}</span>
            <input type="number" pInputText class="fieldInput" formControlName="num_max"
                  (change)="changeMax($event, minNum.value)" [min]="minNum.value" [attr.disabled]="readonly ? '' : null" #maxNum/>
            <span class="input-error-notification" *ngIf="invalidSubmit && form.controls.num_max.errors?.integerNotNegative">Solo valori interi positivi</span>
            <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="form" [arrayValidators]="[validators.integerNotNegative]" [validation]="fields.num_max"></app-validation-msg>
          </div>

        </div>

        <div class="ui-g ui-g-12" class="messageConflict" *ngIf="render.messageConflict">
          <p-accordion>
            <p-accordionTab [header]="messageConflict">
              {{stringCards}}
            </p-accordionTab>
          </p-accordion>
        </div>

      </div>
    </div>

</form>



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-card-batch/form-card-batch/form-card-batch.component.html